import { Button, Stack, Typography } from "@mui/material";
import { useAuth } from "@poseidon/ui/components/AuthContext";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

export default function RequireAuth({ children }) {
  let auth = useAuth();
  let location = useLocation();
  let navigate = useNavigate();

  if ("not-logged-in" === auth.state) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  } else if ("logged-in" === auth.state && auth.user) {
    return children;
  } else {
    return (
      <Stack
        sx={{
          flex: 1,
          flexGrow: 1,
          height: "100vh",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography variant="subtitle1" mb={2}>
          Access Deined
        </Typography>
        <Button variant="contained" onClick={() => navigate("/auth/login")}>
          Back to Login
        </Button>
      </Stack>
    );
  }
}
